<script setup lang="ts">
import { computed } from "vue";

import SVGWrapper from "./utils/SVGWrapper.vue";

import type { colorTag } from "@/Modules/App/Models/Styles/Colors";
import type { iconSize } from "@/Modules/App/Models/Styles/Icons";

export interface IconProps {
  size?: iconSize;
  color?: colorTag;
  background?: colorTag;
}

const props = withDefaults(defineProps<IconProps>(), { color: "content-high", size: "md" });

const colorClass = computed((): string => `fill-${props.color}`);
</script>

<template>
  <SVGWrapper :size="size" :background="background" viewBox="0 0 17 20">
    <path
      d="M17 2.35294V20H0V2.35294H2.53867V3.52941H1.13333V18.8235H15.8667V3.52941H14.416V2.35294H17ZM13.6 5.88235H3.4V1.17647H6.902C7.14 0.494118 7.76333 0 8.5 0C9.23667 0 9.87133 0.494118 10.098 1.17647H13.6V5.88235ZM12.4667 2.35294H9.06667V1.76471C9.06667 1.43529 8.81733 1.17647 8.5 1.17647C8.18267 1.17647 7.93333 1.43529 7.93333 1.76471V2.35294H4.53333V4.70588H12.4667V2.35294Z"
      :class="colorClass"
    />

    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M13.1563 8.97106L7.53669 16.3637L3.99866 13.5453L4.74635 12.6067L7.27863 14.6239L12.1684 8.28992L13.1563 8.97106Z"
      :class="colorClass"
    />
  </SVGWrapper>
</template>

<style scoped lang="scss"></style>
